import { render, staticRenderFns } from "./monthlyCarRenewal.vue?vue&type=template&id=724dd65a&scoped=true"
import script from "./monthlyCarRenewal.vue?vue&type=script&lang=js"
export * from "./monthlyCarRenewal.vue?vue&type=script&lang=js"
import style0 from "./monthlyCarRenewal.vue?vue&type=style&index=0&id=724dd65a&prod&scoped=true&lang=css"
import style1 from "./monthlyCarRenewal.vue?vue&type=style&index=1&id=724dd65a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724dd65a",
  null
  
)

export default component.exports